export const STATUS_OK = 200,
	STATUS_CREATED = 201,
	STATUS_ACCEPTED = 202,
	STATUS_NO_CONTENT = 202,
	STATUS_UNAUTHORIZED = 401,
	STATUS_UNPROCESSABLE_ENTITY = 422,
	STATUS_SERVER_ERROR = 500,
	STATUS_BAD_REQUEST = 400,
	STATUS_NOT_FOUND = 404

export const AUTH_TOKEN = 'auth_token'

export const API_JWT_BASE_URL = '/api/dt'
export const API_V2_BASE_URL = '/api/v2'
